// extracted by mini-css-extract-plugin
export default {"container":"EmailConfirmationValidate_container__mD63V","card":"EmailConfirmationValidate_card__Df-bQ","title":"EmailConfirmationValidate_title__M81vx"};